import { RoomReward } from "../Model/RoomReward";
import { RoomRewards } from "../Model/RoomRewards";
export class RoomsService {
    constructor(httpService, roomsFactory, gamesFactory, playersFactory) {
        this.httpService = httpService;
        this.roomsFactory = roomsFactory;
        this.gamesFactory = gamesFactory;
        this.playersFactory = playersFactory;
    }
    async getRoom(roomId) {
        // e-2001
        const response = await this.httpService.get(`room/${roomId}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener la sala.');
        }
        return this.createRoom(await response.json());
    }
    async getAccountRooms(accountId) {
        // e-2002
        const response = await this.httpService.get(`account/${accountId}/rooms`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener las salas de la cuenta.');
        }
        const content = await response.json();
        return content.map((data) => this.createRoom(data));
    }
    async getCurrentGameAtRoom(roomId) {
        // e-2003
        const response = await this.httpService.get(`room/${roomId}/game`);
        if (response.status === 404) {
            return null;
        }
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener la sala.');
        }
        return this.createGame(await response.json());
    }
    async getRoomStateReport(roomId) {
        const response = await this.httpService.get(`room/${roomId}/report`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener el informe de estado de sala.');
        }
        const { room, game, players } = await response.json();
        return {
            room: this.createRoom(room),
            game: this.createGame(game),
            players: players.map(data => this.createPlayer(data))
        };
    }
    async getPlayersInRoom(roomId) {
        const response = await this.httpService.get(`room/${roomId}/players`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener los jugadores en la sala.');
        }
        const content = await response.json();
        return content.map((data) => this.createPlayer(data));
    }
    async getPlayersInRoomAndGame(roomId, gameId) {
        const response = await this.httpService.get(`room-games/${roomId}/${gameId}/players`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener los jugadores en la sala.');
        }
        const content = await response.json();
        return content.map((data) => this.createPlayer(data));
    }
    async getRoomsStates() {
        const response = await this.httpService.get('rooms-states');
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener los estados de las salas.');
        }
        return response.json();
    }
    async getRooms() {
        const response = await this.httpService.get('rooms');
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener las salas.');
        }
        const content = await response.json();
        return content.map(data => this.createRoom(data));
    }
    async saveRoom(room) {
        const response = await this.httpService.post('room', room);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al guardar la sala.');
        }
        const roomData = await response.json();
    }
    async removeRoom(roomId) {
        const response = await this.httpService.delete(`room/${roomId}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al eliminar la sala.');
        }
    }
    createRoom(data) {
        const bingo = new RoomReward(data.roomRewards.bingo.text);
        const figure = new RoomReward(data.roomRewards.figure.text);
        const roomsRewards = new RoomRewards(bingo, figure);
        return this.roomsFactory.createRoom(data.accountId, data.id, data.enabled, data.integratedDisplay, data.showRoomQrInMonitor, data.pictureId, data.name, data.secondsBetweenMessages, data.state, data.gallery, roomsRewards, data.offline, data.chroma, data.chromaColor);
    }
    createGame(data) {
        if (!data) {
            return null;
        }
        return this.gamesFactory.createGame(data.id, data.code, data.roomId, data.managerId, new Date(data.creationDate), data.type, data.state, data.waitTime, data.numbers, data.useChecker, data.playWithPaper);
    }
    createPlayer(playerDto) {
        return this.playersFactory.createPlayerFromDto(playerDto);
    }
}
